import { FormattedMessage } from 'react-intl';

import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import Inset from '~/modules/ui-kit/spacings/inset';

import ContentView from '~/components/ContentView';
import DrawerButton from '~/containers/DrawerButton';
import { ReactComponent as PrivacyPolicyDocument } from '~/privacy.md';
import messages from './messages';

export const PrivacyPolicy = () => {
  const theme = useTheme();

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <DrawerButton />
            <Typography
              variant="h6"
              style={{ flexGrow: 1, marginLeft: theme.spacing(2) }}
              sx={{
                color: 'inherit',
              }}
            >
              <FormattedMessage {...messages.title} />
            </Typography>
          </Toolbar>
        </AppBar>
      }
    >
      <Inset>
        <PrivacyPolicyDocument />
      </Inset>
    </ContentView>
  );
};

PrivacyPolicy.displayName = 'PrivacyPolicy';

export default PrivacyPolicy;
